import React, { useState } from 'react';
import axios from 'axios';
import toast from 'react-hot-toast';

const STATUS_COLORS = { pending: 'badge-warning', confirmed: 'badge-success', completed: 'badge-primary', cancelled: 'badge-danger', no_show: 'badge-danger' };
const STATUS_TEXT = { pending: '⏳ Pending', confirmed: '✅ Confirmed', completed: '✔️ Completed', cancelled: '❌ Cancelled', no_show: '❌ No Show' };

export default function MyBookings() {
  const [phone, setPhone] = useState('');
  const [bookings, setBookings] = useState(null);
  const [loading, setLoading] = useState(false);
  const [searched, setSearched] = useState(false);

  const handleSearch = async (e) => {
    e.preventDefault();
    if (!phone.trim()) return toast.error('Phone number daalein');
    setLoading(true); setSearched(true);
    try {
      const r = await axios.get('/api/public/my-bookings', { params: { phone } });
      setBookings(r.data.bookings);
      if (r.data.bookings.length === 0) toast('Koi booking nahi mili', { icon: 'ℹ️' });
    } catch { toast.error('Error'); }
    setLoading(false);
  };

  const callShop = (waNumber) => {
    let p = waNumber.replace(/[^0-9]/g, '');
    if (p.startsWith('0')) p = '92' + p.substring(1);
    window.open(`https://wa.me/${p}`, '_blank');
  };

  return (
    <div style={{ minHeight: '100vh', background: 'var(--bg)' }}>
      <div style={{ background: 'var(--primary)', padding: '32px 20px', color: 'white' }}>
        <div style={{ maxWidth: '900px', margin: '0 auto' }}>
          <a href="/" style={{ color: 'rgba(255,255,255,0.6)', textDecoration: 'none', fontSize: '14px' }}>← Home</a>
          <h1 style={{ fontFamily: 'Syne', fontSize: '32px', marginTop: '12px' }}>📋 Meri Bookings</h1>
          <p style={{ color: 'rgba(255,255,255,0.6)', marginTop: '8px' }}>Apna phone number daal kar saari bookings dekhein</p>
        </div>
      </div>

      <div style={{ maxWidth: '900px', margin: '0 auto', padding: '32px 20px' }}>
        <div className="card mb-4">
          <form onSubmit={handleSearch}>
            <div className="flex gap-3" style={{ flexWrap: 'wrap' }}>
              <div style={{ flex: 1, minWidth: '200px' }}>
                <label className="form-label">📱 Phone Number</label>
                <input className="form-control" placeholder="03XXXXXXXXX ya 923XXXXXXXXX"
                  value={phone} onChange={e => setPhone(e.target.value)} />
              </div>
              <div style={{ alignSelf: 'flex-end' }}>
                <button className="btn btn-primary btn-lg" type="submit" disabled={loading}>
                  {loading ? 'Search...' : '🔍 Search'}
                </button>
              </div>
            </div>
          </form>
        </div>

        {searched && bookings && bookings.length === 0 && (
          <div className="card" style={{ textAlign: 'center', padding: '60px 20px' }}>
            <div style={{ fontSize: '64px', marginBottom: '12px' }}>📭</div>
            <h3>Koi Booking Nahi Mili</h3>
            <p style={{ color: 'var(--text-light)', marginTop: '8px' }}>Yeh number par koi booking nahi hai. Phone number check karein.</p>
          </div>
        )}

        {bookings && bookings.length > 0 && bookings.map(b => (
          <div key={b.id} className="card card-hover mb-3" style={{ borderLeft: `4px solid ${b.status === 'confirmed' ? 'var(--success)' : b.status === 'completed' ? 'var(--primary)' : b.status === 'pending' ? 'var(--gold)' : 'var(--danger)'}` }}>
            <div className="flex-between" style={{ flexWrap: 'wrap', gap: '12px' }}>
              <div style={{ flex: 1, minWidth: '250px' }}>
                <div className="flex gap-2" style={{ marginBottom: '8px', flexWrap: 'wrap' }}>
                  <span className={`badge ${STATUS_COLORS[b.status]}`}>{STATUS_TEXT[b.status]}</span>
                  <span style={{ fontSize: '12px', color: 'var(--text-light)', fontFamily: 'monospace' }}>{b.booking_ref}</span>
                </div>
                <h3 style={{ fontSize: '18px', marginBottom: '4px' }}>{b.shop_name}</h3>
                <p style={{ fontSize: '13px', color: 'var(--text-light)' }}>📍 {b.city}</p>
                <div style={{ marginTop: '12px', fontSize: '14px' }}>
                  <div>📅 <strong>{new Date(b.booking_date).toLocaleDateString('en-PK', { weekday: 'short', day: 'numeric', month: 'short', year: 'numeric' })}</strong> ⏰ {b.booking_time?.slice(0,5)}</div>
                  {b.service_name && <div style={{ marginTop: '4px' }}>✂️ {b.service_name} {b.service_price > 0 && <span style={{ color: 'var(--success)', fontWeight: 600 }}>— PKR {Number(b.service_price).toLocaleString()}</span>}</div>}
                  {b.staff_name && <div style={{ marginTop: '4px' }}>💈 Barber: {b.staff_name}</div>}
                </div>
              </div>
              <div className="flex gap-2" style={{ flexDirection: 'column', alignItems: 'flex-end' }}>
                <button className="btn btn-whatsapp btn-sm" onClick={() => callShop(b.whatsapp_number)}>📲 Shop se Baat Karein</button>
                <a href={`/shop/${b.slug}`} className="btn btn-outline btn-sm">Shop Page →</a>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
